import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ArtistService from '../../services/artistService';

const NewResource = (props) => { 
    const item = props.item;
    return (        
        <li>
            <div className="feed-icon">               
                {
                    item.ResourceType === 'Music' ?
                        <svg className="icon icon-music transition">
                            <use xlinkHref="#icn-music" />
                        </svg>
                        :
                        <svg className="icon icon-tv transition">
                            <use xlinkHref="#icn-tv" />
                        </svg>
                }
            </div>
            <Link to={`/${item.Username}`} className="thumbnail">
                <div className="userthumb">
                    <img src={props.getThumbnail(item.Thumbnail, item.RoleType)} alt="profile picture" />
                </div>
            </Link>
            <p className="type">NEW {item.ResourceType.toUpperCase().replace("Music", "Track")} ADDED <span className="time">{item.DateText}</span></p>
            <div className="message">
                <p>
                    <Link to={`/${item.Username}`}><strong>{item.DisplayName}</strong> ({ArtistService.getRoleTypeFriendlyName(item.RoleType)})</Link> has added a new {item.ResourceType.toLowerCase().replace("music", "track")} called '<Link to={`${item.ResourceType === 'Music' ? '/Track' : 'Video'}/${item.ResourceID}`}><strong>{item.ResourceName}</strong></Link>'. Check it out!
                </p>
            </div>
        </li>  
    );
};

NewResource.propTypes = {
    item: PropTypes.object.isRequired,
    getThumbnail: PropTypes.func.isRequired
};

export default NewResource;